import { observer } from 'mobx-react';
import React from 'react';

const createDetailZNSTemplate = () => {
  return observer(() => {
    // Chưa cấu hình đượ router nên chưa move trang chi tiết qua
    return <div>DetailZNSTemplate</div>;
  });
};

export default createDetailZNSTemplate;
